// extracted by mini-css-extract-plugin
export default {"container":"styles_container__ILhoO","gradient":"styles_gradient__aQ5QZ","content":"styles_content__4G6o4","logo":"styles_logo__gepXR"};